import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ArticleCard } from "../components/site/Cards";
import { catLabel, fmtDate, img, useGet } from "../lib/api";

export default function ArtikelDetail() {
  const { slug } = useParams();
  const { data: a, isLoading, isError } = useGet("article", `/articles/${slug}`);
  const { data: related } = useGet("articles", "/articles", { category: a?.category });

  if (isLoading) return <p className="mx-auto max-w-3xl px-5 py-20">Memuat artikel...</p>;
  if (isError) return <p className="mx-auto max-w-3xl px-5 py-20" data-testid="article-not-found">Artikel tidak ditemukan.</p>;

  return (
    <article className="pb-20" data-testid="article-detail">
      <div className="mx-auto max-w-3xl px-5 pt-12">
        <Link to="/edukasi" className="inline-flex items-center gap-2 text-sm font-medium text-[var(--forest)]" data-testid="article-back-link">
          <ArrowLeft className="h-4 w-4" /> Pojok Edukasi
        </Link>
        <div className="mt-6 flex items-center gap-3 text-sm">
          <Link to={`/edukasi?kategori=${a.category}`} className="rounded-full bg-[var(--gold-soft)] px-3 py-1 font-semibold text-[var(--earth)]">{catLabel(a.category)}</Link>
          <span className="text-[var(--ink)]/50" data-testid="article-date">{fmtDate(a.created_at)}</span>
        </div>
        <h1 className="mt-4 font-display text-4xl font-semibold leading-tight text-[var(--forest-dark)] sm:text-5xl" data-testid="article-title">{a.title}</h1>
      </div>
      <div className="mx-auto mt-10 max-w-5xl px-5">
        <img src={img(a.thumbnail_url)} alt={a.title} className="aspect-[16/8] w-full rounded-3xl object-cover" />
      </div>
      <div className="article-content mx-auto mt-12 max-w-3xl px-5" data-testid="article-content" dangerouslySetInnerHTML={{ __html: a.content }} />
      {related?.filter((r) => r.slug !== a.slug).length > 0 && (
        <section className="mx-auto mt-20 max-w-7xl px-5 lg:px-8">
          <h2 className="mb-8 font-display text-2xl font-semibold text-[var(--forest-dark)]">Artikel Terkait</h2>
          <div className="grid gap-7 md:grid-cols-3">
            {related.filter((r) => r.slug !== a.slug).slice(0, 3).map((r) => <ArticleCard key={r.id} a={r} />)}
          </div>
        </section>
      )}
    </article>
  );
}
